import React from 'react';
import { ClipboardList, CalendarCheck, Home } from 'lucide-react';

const steps = [
  {
    icon: <ClipboardList className="w-10 h-10" />,
    title: "Step 1",
    subtitle: "Request a quote",
    description: "Fill out our simple form or give us a call to get a personalized estimate."
  },
  {
    icon: <CalendarCheck className="w-10 h-10" />,
    title: "Step 2",
    subtitle: "Schedule your cleaning",
    description: "Pick a date and time that works for you. We're flexible and reliable."
  },
  {
    icon: <Home className="w-10 h-10" />,
    title: "Step 3",
    subtitle: "Enjoy a spotless home",
    description: "Relax while our professionals make your home shine. 100% satisfaction guaranteed."
  }
];

const HowItWorks: React.FC = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-6">
            How It <span className="text-brand-blue">Works</span>
          </h2>
          <p className="text-lg text-brand-navy/70">
            Booking your professional cleaning service is as easy as 1-2-3.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
          {/* Connector Line (Desktop) */}
          <div className="hidden md:block absolute top-1/4 left-0 right-0 h-0.5 bg-brand-blue/10 -z-10"></div>
          
          {steps.map((step, index) => (
            <div key={index} className="text-center space-y-6 group">
              <div className="w-24 h-24 bg-white border-2 border-brand-blue/10 rounded-full flex items-center justify-center text-brand-blue mx-auto shadow-premium group-hover:border-brand-blue group-hover:bg-brand-blue group-hover:text-white transition-all duration-500 transform group-hover:scale-110">
                {step.icon}
              </div>
              <div className="space-y-2">
                <p className="text-xs font-black text-brand-blue uppercase tracking-widest">{step.title}</p>
                <h3 className="text-2xl font-bold text-brand-navy">{step.subtitle}</h3>
              </div>
              <p className="text-brand-navy/60 leading-relaxed max-w-xs mx-auto">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
